<!-- Footer -->
<div class="clearfix mb-0">
  <div class="container-lg py-2">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <h2 class="montserrat font-weight-lighter text-white">CAD GRAFICS</h2>
        <div class="row mt-1">
          <div class="col-md-8 d-flex">
            <i class="feather icon-map-pin font-medium-5 mr-1 text-white"></i>
            <a href="https://maps.app.goo.gl/1dPpc7WvhWcGR5YT9" target="_blank">
              <p class="text-white nutmeg mb-0">Calle Dia # 2381 (entre Lluvia y Tormenta)</p>
              <p class="text-white nutmeg">Col. Jardines del Bosque • C.P. 44520</p>
            </a>
          </div>
          <div class="col d-flex">
            <i class="feather icon-phone font-medium-5 mr-1 text-white"></i>
            <a href="tel:3338182800" class="text-white nutmeg">+52 (33) 1404-0396</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-lg-2 pl-lg-4 border-separator d-flex justify-content-center align-items-center">
        <picture>
          <!-- <img class="img-fluid" src="assets/images/misc/administracion-gray.webp" alt="Administración"> -->
        </picture>
      </div>
    </div>
  </div>
</div>
